import { Link } from "react-router-dom";
import { ArrowUpRight, Check } from "lucide-react";
import { KineticHeading } from "../components/site/KineticHeading";
import { Reveal } from "../components/site/Reveal";
import { useContent } from "../context/ContentContext";
import { img } from "../lib/api";

export default function Services() {
  const { site } = useContent();
  const services = site.services || [];
  return (
    <>
      <section className="mx-auto max-w-[1400px] px-6 pb-16 pt-40 md:px-10 md:pt-48" data-testid="services-hero">
        <div className="mb-6 text-xs font-bold uppercase tracking-[0.25em] text-volt">Services</div>
        <KineticHeading lines={["Three pillars.", "End-to-end."]}
          className="font-display text-5xl font-semibold uppercase leading-[0.95] tracking-tighter sm:text-7xl lg:text-8xl" />
        <p className="mt-8 max-w-2xl text-lg text-white/60">
          From the first registration email to the last badge collected — and everything loud, shiny and shareable in between.
        </p>
      </section>

      <div className="mx-auto max-w-[1400px] px-6 pb-28 md:px-10">
        {services.map((s, idx) => (
          <section key={s.id || idx} data-testid={`service-block-${s.id || idx}`} className="grid items-center gap-10 border-t border-white/10 py-20 md:grid-cols-2 md:gap-16">
            <Reveal className={idx % 2 === 1 ? "md:order-2" : ""}>
              <div className="group relative overflow-hidden rounded-2xl border border-white/10">
                <img src={img(s.image)} alt={s.title} className="aspect-[4/3] w-full object-cover transition-transform duration-700 group-hover:scale-105" />
                <div className="absolute inset-0 bg-black/20" />
                <span className="absolute left-5 top-5 font-mono text-sm text-volt">{s.index}</span>
              </div>
            </Reveal>
            <Reveal delay={0.1}>
              <h2 className="font-display text-4xl font-medium tracking-tight sm:text-5xl">{s.title}</h2>
              <p className="mt-4 text-xl text-volt">{s.tagline}</p>
              <p className="mt-3 text-white/60">{s.summary}</p>
              <ul className="mt-8 space-y-4">
                {(s.points || []).map((p) => (
                  <li key={p} className="flex gap-3 text-white/70">
                    <Check size={20} className="mt-0.5 flex-shrink-0 text-volt" />
                    <span>{p}</span>
                  </li>
                ))}
              </ul>
              <div className="mt-10 flex flex-wrap gap-4">
                <Link to={`/products?category=${encodeURIComponent(s.category || "")}`} data-testid={`service-products-${s.id || idx}`} className="brand-gradient inline-flex items-center gap-2 rounded-full px-6 py-3 font-semibold text-white transition-transform hover:-translate-y-0.5">
                  View products <ArrowUpRight size={18} />
                </Link>
                <Link to="/contact" className="inline-flex items-center gap-2 rounded-full border border-white/20 px-6 py-3 font-semibold text-white transition-colors hover:bg-white/5">
                  Talk to us
                </Link>
              </div>
            </Reveal>
          </section>
        ))}
      </div>

      <section className="border-t border-white/10 bg-korio-surface py-24 text-center" data-testid="services-cta">
        <div className="mx-auto max-w-[1400px] px-6 md:px-10">
          <h2 className="font-display text-4xl font-medium tracking-tight sm:text-5xl">One team. Every discipline.</h2>
          <Link to="/contact" className="brand-gradient mt-8 inline-flex rounded-full px-8 py-4 font-semibold text-white transition-transform hover:-translate-y-0.5">Brief us</Link>
        </div>
      </section>
    </>
  );
}
